export function formatCanvasVersionLabel(versionIndex: number): string {
  return `v${versionIndex + 1}`;
}
